import { onDocumentReady } from '../utils/events';

onDocumentReady(() => {
    function infiniteTicker() {
        let secAnim = 10;

        let $logoScrollerMainContainer = $('.infinite-ticker__main-container');
        $('.infinite-ticker__track--copied').remove();

        let $logoScrollerMainTrack = $('.infinite-ticker__track:not(.infinite-ticker__track--copied)');

        if ($logoScrollerMainContainer.length && $logoScrollerMainTrack.length) {
            let containerWidth = $logoScrollerMainContainer.width();
            let logoScrollerMainTrackWidth = $logoScrollerMainTrack.width();

            if (logoScrollerMainTrackWidth <= 0) return;

            let containerWidth_X2 = containerWidth * 2;
            let maxCount = Math.ceil(containerWidth_X2 / logoScrollerMainTrackWidth);
            let counter = 0;

            const getTracksWidth = () => {
                let result = 0;
                $('.infinite-ticker__track').each(function () {
                    result += $(this).outerWidth();
                });
                return result;
            };

            do  {
                let trackHtml = $logoScrollerMainTrack.html();
                if (trackHtml) {
                    $logoScrollerMainTrack.after(
                        $('<div class="infinite-ticker__track infinite-ticker__track--copied">').html(trackHtml)
                    );
                }
                counter++;
            } while(getTracksWidth() < containerWidth_X2 && counter < maxCount);

            let finalSec = secAnim * (logoScrollerMainTrackWidth / 500);

            $logoScrollerMainContainer.css('--width-for-anim', (logoScrollerMainTrackWidth * -1) + 'px');
            $logoScrollerMainContainer.css('--sec-for-anim', finalSec + 's');
        }
    }

    infiniteTicker();

    let resizeTimer;
    $(window).on('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            infiniteTicker();
        }, 250);
    });
});